import Drawer from './Drawer'
import { withDrawer } from './withDrawer'

const ConnectedDrawer = withDrawer(Drawer)

export { ConnectedDrawer as Drawer }
